"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCdnImageUrlForAccountType = getCdnImageUrlForAccountType;
const get_cdn_image_url_1 = require("@shared/get-cdn-image-url");
const types_1 = require("@src/types");
function getCdnImageUrlForAccountType(imageSrc, accountType, transformation) {
    if (!imageSrc) {
        return null;
    }
    // Values can be short ids (company/account images), full storage keys, or
    // absolute URLs — pass the latter two through.
    if (/^https?:\/\//i.test(imageSrc) || imageSrc.startsWith(`${process.env.ENVIRONMENT}/`)) {
        return (0, get_cdn_image_url_1.getCdnImageUrl)({ file: imageSrc, transformation });
    }
    // Static assets live outside the environment prefix by design.
    if (imageSrc.startsWith('static/')) {
        return (0, get_cdn_image_url_1.getCdnImageUrl)({ file: imageSrc, transformation, shouldIncludeEnvironmentPart: false });
    }
    const cdnFolder = accountType === types_1.AccountType.company ? 'company' : 'account';
    return (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: `web/${cdnFolder}/${imageSrc}`,
        transformation,
    });
}
